import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MuiButton from '@material-ui/core/Button';
import FormHelperText from '@material-ui/core/FormHelperText';

import { SERVICE_AREAS } from '../../../constants';

const propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }).isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool,
    invalid: PropTypes.bool,
  }).isRequired,
  enableEditing: PropTypes.bool,
  classes: PropTypes.shape({
    serviceAreaButtonsContain: PropTypes.string,
    serviceAreaButtons: PropTypes.string,
    serviceAreaButtonsLeft: PropTypes.string,
    buttonActive: PropTypes.string,
  }).isRequired,
};

const defaultProps = {
  enableEditing: false,
};

const renderFromHelper = ({ touched, error, classes }) => {
  if (touched && error) {
    return (
      <FormHelperText className={classes.errMsg}>
        {touched && error}
      </FormHelperText>
    );
  }
  return null;
};

export const ServiceAreaButtons = props => {
  const {
    input: { value, onChange },
    classes,
    meta: { error, touched },
    enableEditing,
  } = props;

  return (
    <>
      <div className={classes.serviceAreaButtonsContain}>
        <MuiButton
          type="button"
          variant="outlined"
          color="primary"
          disabled={enableEditing}
          className={classNames(
            classes.serviceAreaButtons,
            classes.serviceAreaButtonsLeft,
            value === SERVICE_AREAS.LOCAL && classes.buttonActive,
          )}
          onClick={() => onChange(SERVICE_AREAS.LOCAL)}
        >
          Local
        </MuiButton>
        <MuiButton
          type="button"
          variant="outlined"
          color="primary"
          disabled={enableEditing}
          className={classNames(
            classes.serviceAreaButtons,
            classes.serviceAreaButtonsCenter,
            value === SERVICE_AREAS.STATEWIDE && classes.buttonActive,
          )}
          onClick={() => onChange(SERVICE_AREAS.STATEWIDE)}
        >
          Statewide
        </MuiButton>
        <MuiButton
          type="button"
          variant="outlined"
          color="primary"
          disabled={enableEditing}
          className={classNames(
            classes.serviceAreaButtons,
            classes.serviceAreaButtonsRight,
            value === SERVICE_AREAS.NATIONAL && classes.buttonActive,
          )}
          onClick={() => onChange(SERVICE_AREAS.NATIONAL)}
        >
          National
        </MuiButton>
      </div>
      {renderFromHelper({ touched, error, classes })}
    </>
  );
};

ServiceAreaButtons.propTypes = propTypes;
ServiceAreaButtons.defaultProps = defaultProps;

renderFromHelper.propTypes = {
  error: PropTypes.string,
  touched: PropTypes.bool,
  classes: PropTypes.object,
};

export default ServiceAreaButtons;
